import $ from 'jquery';

/**
 * @param {string} text
 */
export const createContentIframe = (text) => {

	const iframe = document.createElement('iframe');
	// iframe.src = 'data:text/html;charset=UTF-8,' + mpro.Sanitize.encodeUri(text);
	iframe.srcdoc = text;

	return iframe;
};

/**
 * Resize iframe
 *
 * @param {HTMLIFrameElement} iframe
 */
// TODO: Optimize this function without jquery
export const resizeIframeToInnerContent = (iframe) => {
	// iframe.style.height = iframe.contentDocument.documentElement.offsetHeight + 'px';
	iframe.style.height = $(iframe.contentDocument.body).outerHeight(true) + 'px';
};

/**
 * @param {HTMLIFrameElement} iframe
 * @param {*} options
 */
export const resizeIframeToViewport = (iframe, options = {}) => {

	iframe.style.height = `calc(100vh - ${iframe.getBoundingClientRect().top}px)`;

	// window.addEventListener('resize', () => {
	// 	// Get iframe position
	// 	const { top } = iframe.getBoundingClientRect();
	// 	iframe.style.height = (window.innerHeight - top) + 'px';
	// }, { passive: true });
};
